export enum EmployeeContactRole {
  Csr = 0,
  Ar = 1,
  Sr = 2,
}

export interface IEmployeeContact {
  name: string;
  email: string;
  phone: string;
  imageUrl: string;
  extension: string;
  employeeContactRole: EmployeeContactRole;
  title: string;
  partyId: string;
}
